import React from "react";
import PropTypes from "prop-types";
import ImmutablePropTypes from "react-immutable-proptypes";

import Card from "components/Card";

import "./PlaceholderCard.css";

export default class PlaceholderCard extends React.Component {

  static propTypes = {
    school: ImmutablePropTypes.shape({
      name: PropTypes.string.isRequired
    }).isRequired,
    objectName: PropTypes.string.isRequired,
    message: PropTypes.string
  }

  render() {
    const schoolName = this.props.school.get("name");
    return (
      <Card>
        <Card.Body>
          <div className="placeholder-card">
            {(this.props.message !== "" && this.props.message !== undefined) ? `${this.props.message}` : `${schoolName} has no ${this.props.objectName} to display.`}
          </div>
        </Card.Body>
      </Card>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/school_money/PlaceholderCard.js